// Back-compat shim over the static-SVG Phosphor catalog.
//
// Previously this deep-imported ~100 icon components and shipped them in the
// bundle. Now icons render from static SVGs via <PhosphorIcon> (CSS mask), so
// the full 1,500+ catalog is available with ~zero JS cost. These helpers keep
// the old call sites working: `getCuratedIcon(name)` still returns a component
// you can render as `<Icon className weight />`.

import { createElement, type ReactElement } from "react";
import { type IconWeight, PhosphorIcon } from "@/components/icons/PhosphorIcon";
import { resolveIconName } from "./resolve";

type BoundIconProps = { className?: string; weight?: IconWeight };

/**
 * Returns a component bound to `name` (renders a masked static SVG), or null
 * for empty/unknown names. Call sites render it as `<Icon className weight />`.
 */
export function getCuratedIcon(name: string | null | undefined) {
  const resolved = resolveIconName(name);
  if (!resolved) return null;
  return function CuratedIcon(props: BoundIconProps): ReactElement {
    return createElement(PhosphorIcon, { name: resolved, ...props });
  };
}

/** Render a curated icon directly. Returns null for empty/unknown names. */
export function renderCuratedIcon(
  name: string | null | undefined,
  className?: string,
): ReactElement | null {
  const resolved = resolveIconName(name);
  if (!resolved) return null;
  return createElement(PhosphorIcon, { name: resolved, className });
}
